
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface BookingRecord {
  id: number;
  created_at: string;
  prompt: string;
  status: 'success' | 'failed';
  error_message?: string;
  attendee_name: string;
  scheduled_time: string;
  organizer_email: string;
  attendee_email: string;
  user_prompt: string;
}

interface BookingsTableProps {
  bookings: BookingRecord[];
}

export const BookingsTable = ({ bookings }: BookingsTableProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Booking History</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Date</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>User Prompt</TableHead>
              <TableHead>System Prompt</TableHead>
              <TableHead>Error</TableHead>
              <TableHead>Organizer</TableHead>
              <TableHead>Organizer Email</TableHead>
              <TableHead>Attendee Name</TableHead>
              <TableHead>Attendee Email</TableHead>
              <TableHead>Meeting Time</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {bookings.map((booking) => (
              <TableRow key={booking.id}>
                <TableCell>
                  {new Date(booking.created_at).toLocaleDateString()}
                </TableCell>
                <TableCell>
                  <span
                    className={`px-2 py-1 rounded-full text-sm ${
                      booking.status === 'success'
                        ? 'bg-green-100 text-green-800'
                        : 'bg-red-100 text-red-800'
                    }`}
                  >
                    {booking.status}
                  </span>
                </TableCell>
                <TableCell className="max-w-md truncate">
                  {booking.user_prompt}
                </TableCell>
                <TableCell className="max-w-md truncate">
                  {booking.prompt}
                </TableCell>
                <TableCell className="max-w-md truncate text-red-600">
                  {booking.error_message}
                </TableCell>
                <TableCell>Organizer</TableCell>
                <TableCell>{booking.organizer_email}</TableCell>
                <TableCell>{booking.attendee_name}</TableCell>
                <TableCell>{booking.attendee_email}</TableCell>
                <TableCell>{booking.scheduled_time}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
